import moment from "moment";

import { TransactionsInboxItem } from "@/Billing/Api/Inbox/Dto/Response/BillingInboxItem";
import { BillingStore } from "@/Billing/Stores/BillingStore";
import { CheckboxTarget } from "@/Common/Models/UI/Inputs/CheckboxTarget";
import * as LocalOperations from "@/Common/Operations/operations.local";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { BaseOperationHandler } from "@/Common/Stores/Handlers/Local/BaseOperationHandler";

class TransactionsInboxHandler extends BaseOperationHandler {
    constructor() {
        super();

        this.RegisterOperation(LocalOperations.Billing.Store_Mounted, this.load_TransactionsData);
        this.RegisterOperation(LocalOperations.Billing.Transactions_Search_CurrentPageChange, this.ResultsPageChange);
        this.RegisterOperation(LocalOperations.Billing.Transactions_SearchSettings_OnResultsPerPageChange, this.ResultsPerPageChange);
        this.RegisterOperation(LocalOperations.Billing.Transactions_Refresh_ButtonClick, this.RefreshButtonClick);
        this.RegisterOperation(LocalOperations.Billing.Transactions_SearchBoxTextChanged, this.Search_TextChanged);
        this.RegisterOperation(LocalOperations.Billing.Transactions_Open_BillingPopup, this.openBillingPopup);
        this.RegisterOperation(LocalOperations.Billing.Transactions_Close_BillingPopup, this.Close_BillingPopup);
        this.RegisterOperation(LocalOperations.Misc.MyleApp_Container_Click, this.OnContainerClick);
        this.RegisterOperation(LocalOperations.Billing.BillingClaimStatusCount, this.refreshCount);
    }

    private openBillingPopup(request: LocalEvent, store: BillingStore): void {
        const data = request.Get<TransactionsInboxItem>("rowData");
        const site = cacheStore.GetSiteById(data.SiteId);

        let discount = 0.0;
        if (data.DiscountType === "$")
            discount = data.Discount_Dollars;
        else if (data.DiscountType === "%")
            discount = data.Discount_Percentage;

        store.BillingPopupModel = store.BillingPopupModel
            .set("PatientId", data.PatientId)
            .set("Site", site)
            .set("InvoiceNumber", data.TransactionNumber)
            .set("Discount", discount)
            .set("DiscountType", data.DiscountType)
            .set("GST", data.SiteGST)
            .set("GSTTotal", data.GST)
            .set("QST", data.SiteQST)
            .set("QSTTotal", data.QST)
            .set("HST", data.SiteHST)
            .set("HSTTotal", data.HST)
            .set("GenericTax", data.SiteGenericTax)
            .set("GenericTaxTotal", data.GenericTax)
            .set("SubTotal", data.SubTotal)
            .set("Total", data.TotalBill)
            .set("DateOfVisit", moment(data.VisitDate).format("YYYY/MM/DD"))
            .set("DateOfVisitFooter", moment(data.TransactionDate).locale(sessionStore.userLanguageCode).format("dddd, LL"))
            .set("ProviderName", data.TransactionProvider)
            .set("BilledByName", data.BilledBy)
            .set("PaymentMethod", data.PaymentMethod)
            .set("BillNote", data.BillNote)
            .set("BilledTo", data.BilledTo)
            .set("RecipientName", data.RecipientName);

        store.BillingAction.OpenSelectedBill(data.PrivateBillId);
    }

    private refreshCount(request: LocalEvent, store: BillingStore): void {
        store.Model = store.Model.set("BillingClaimStatusCount", request.Get<number>("claimcount"));
    }

    private Close_BillingPopup(request: LocalEvent, store: BillingStore): void {
        store.TransactionsInboxModel = store.TransactionsInboxModel.set("BillingPopupIsVisible", false);
        sessionStore.hideGlobalOverlay();
    }
    private OnContainerClick(request: LocalEvent, store: BillingStore): void {
        if (store.TransactionsInboxModel.get("BillingPopupIsVisible") === true) {
            this.Close_BillingPopup(request, store);
        }
    }
    private load_TransactionsData(request: LocalEvent, store: BillingStore): void {
        store.loadTransactionsProviderUICache();
        store.loadTransactionsBilledByClinicianUICache();
        store.TransactionsInboxModel = store.TransactionsInboxModel.set("PaymentMethod", store.initializeBillingPaymentMethod(CheckboxTarget.Myle_Billing_Transactions_PaymentMethod));
        store.TransactionsInboxModel = store.TransactionsInboxModel.set("Status", store.initializeBillingStatus(CheckboxTarget.Myle_Billing_Transactions_Status));
        store.TransactionsInboxModel = store.TransactionsInboxModel.set("Validity", store.initializeBillingValidity(CheckboxTarget.Myle_Billing_Settings_Validity));

        store.BillingAction.LoadTransactionsData(store.TransactionsInboxModel);
    }

    private ResultsPageChange(request: LocalEvent, store: BillingStore): void {
        var value = request.Get<number>("Page");
        store.TransactionsInboxModel = store.TransactionsInboxModel.set("SelectedPageNumber", value);
        store.BillingAction.LoadTransactionsData(store.TransactionsInboxModel);
    }

    private ResultsPerPageChange(request: LocalEvent, store: BillingStore): void {
        store.TransactionsInboxModel = store.TransactionsInboxModel
            .set("SelectedPageNumber", 1)
            .set("SelectedPageSizeOption", request.Get<number>("value"));
    }

    private RefreshButtonClick(request: LocalEvent, store: BillingStore): void {
        store.TransactionsInboxModel = store.TransactionsInboxModel.set("SelectedPageNumber", 1);
        store.BillingAction.LoadTransactionsData(store.TransactionsInboxModel);
    }

    private Search_TextChanged(request: LocalEvent, store: BillingStore): void {
        store.TransactionsInboxModel = store.TransactionsInboxModel.set("SelectedPageNumber", 1);
        store.TransactionsInboxModel = store.TransactionsInboxModel.set("GlobalTransactionsSearchText", request.Get<string>("value"));
        store.BillingAction.LoadTransactionsData(store.TransactionsInboxModel);
    }
}

export { TransactionsInboxHandler };
